import React from 'react';


/**
 * Element enables fast and simple modification of texts (color / size)
 * @param className
 * @param bold
 * @param uppercase
 * @param inline switch between <div> and <span>
 * @param hover set a hover-color, default is blue
 * @param ellipsis text cut off and end with "..." when too long
 * @param color black or defined
 * @param size normal or defined
 * @param breakword break long words
 * @param props
 *
 */
export const Text = ({className, bold, uppercase, inline, hover, ellipsis, color, size, breakword, ...props}) => {
    // make "blue" default value for hover
    if (hover && typeof hover == 'boolean') {
        hover = 'blue';
    }

    const cn = [
        bold && 'bold',
        uppercase && 'uppercase',
        (ellipsis && 'ellipsed') || null,
        size || null,
        color || null,
        'text',
        (hover && ('hover ' + hover)) || null,
        breakword && 'breakword',
        className || null
    ].filter(n => n).join(' '); // filter all empty, null, false and undefined

    return inline ?
        <span className={cn} {...props} /> :
        <div className={cn} {...props} />;
};
